import { render, staticRenderFns } from "./PrivacyHw.vue?vue&type=template&id=7e85e115&scoped=true"
import script from "./PrivacyHw.vue?vue&type=script&lang=js"
export * from "./PrivacyHw.vue?vue&type=script&lang=js"
import style0 from "./PrivacyHw.vue?vue&type=style&index=0&id=7e85e115&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e85e115",
  null
  
)

export default component.exports